import { motion } from 'framer-motion';
import SectionHeading from '../../../components/ui/SectionHeading';
import Button from '../../../components/ui/Button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
// Modifiez le chemin d'importation si nécessaire
import schoolVideo from '../../../assets/videos/NotreEtab.mp4'; // Changez l'extension en .mp4

const AboutSection = () => {
  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-2 md:order-1"
          >
            <SectionHeading
              title="Notre établissement"
              subtitle="À propos de nous"
            />
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Le Groupe Scolaire Sanaa est un pionnier de l'enseignement à Casablanca, doté d'une expérience de plus de Vingt ans, desservant la maternelle, le primaire, le collège et le lycée avec un enseignement solidement ancré dans la pédagogie du 21ème siècle et construit autour d'un programme multilingue.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Notre mission est de former des citoyens responsables, créatifs et ouverts sur le monde, capables de s'adapter aux défis futurs tout en restant attachés à leurs valeurs culturelles.
            </p>
            
            <Button 
              to="/notre-ecole" 
              variant="primary"
              icon={<ArrowRightIcon className="h-5 w-5" />}
            >
              En savoir plus
            </Button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-1 md:order-2"
          >
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-32 h-32 bg-primary rounded-tl-3xl z-0"></div>
              <video 
                className="rounded-lg shadow-elegant w-full h-[400px] object-cover relative z-10"
                autoPlay
                muted
                loop
                playsInline
                controls
                onError={(e) => {
                  console.error('Erreur de chargement vidéo:', e);
                }}
              >
                <source src={schoolVideo} type="video/mp4" />
                <source src={schoolVideo} type="video/webm" />
                <source src={schoolVideo} type="video/quicktime" />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-secondary rounded-br-3xl z-0"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;